import React, { useState, useEffect } from "react"
import { toast } from "react-toastify";
import {  useLazyCartViewQuery } from "../redux/Api/api";

import { useNavigate } from "react-router-dom";


const OrderSummary = () => {
    const [quantities, setQuantities] = useState([]);
    const [cartItems, setCartItems] = useState([]);
    const [cartCount, setCartCount] = useState(0);
    const [fetchCart] = useLazyCartViewQuery();
    const [cartlist] = useLazyCartViewQuery()

    const navigate = useNavigate();

    const convertToPaise = (amount) => Math.round(amount * 100);
    const user = JSON.parse(localStorage.getItem("user"));

    useEffect(() => {
        if (user && user._id) {
            fetchCart(user._id)
                .unwrap()
                .then((items) => {
                    setCartItems(items);
                    setQuantities(items.map((item) => item.quantity || 1));
                    setCartCount(items.length);
                })
                .catch((err) => {
                    console.error("Error fetching cart data:", err);
                    toast.error("Error fetching cart items.");
                });
        } else {
            toast.error("Please log in first.");
        }
    }, []);

    const paymentFun = () => {
        if (!window.Razorpay) {
            console.error("Razorpay SDK is not loaded");
            return;
        }
        const options = {
            key: "rzp_test_2ZQgDDm96U20lT",
            amount: convertToPaise(totalPrice + 50),
            currency: "INR",
            name: "SaiAquapets",
            description: "Payment for test order",
            prefill: {
                email: "info@saiaquapets@gmail.com",
                contact: "+91 63838 89291",
                name: "Harish Kumar Narayanaswamy",
            },
            theme: { color: "#1106AC" },
        };
        const rzp = new window.Razorpay(options);
        rzp.on("payment.success", (response) => {
            toast.success("Payment Success!");
            console.log("Success Data:", response);
            navigate("home");
        });
        rzp.on("payment.error", (error) => {
            toast.error("Payment Failed!");
            console.error("Error Data:", error);
        });
        rzp.open();
    };
    const totalPrice = cartItems.reduce((acc, item) => {
        const price = item.product?.price || 0;
        const quantity = quantities[cartItems.indexOf(item)] || 1;
        return acc + price * quantity;
    }, 0);



    return (
        <div className="md:w-1/3 shadow-md border border-gray-300 bg-white p-5">
            <h2 className="text-xl font-bold mb-4">Order Summary</h2>
            <p className="text-gray-600 mb-2">Subtotal: Rs {totalPrice.toFixed(2)}</p>
            <p className="text-gray-600 mb-4">Delivery Charges: Rs 50</p>
            <p className="font-bold text-lg mb-6">
                Total: Rs {(totalPrice + 50).toFixed(2)}
            </p>
            <button
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 w-full"
                onClick={paymentFun}
            >
                Checkout
            </button>
        </div>
    );
};

export default OrderSummary;
